import { combineReducers } from 'redux-immutable';
import { userLoginReducer } from './login';

export default combineReducers({
  login: userLoginReducer,
});
